module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-57x57-2a26d32287457ecdb14228954c1bd2c4.png";